import type { SpeiseAnsicht } from "../api";
import { euro } from "../geld";

interface Props {
  speisen: SpeiseAnsicht[];
  onHinzufuegen: (speise: SpeiseAnsicht) => void;
}

/** Die Speisekarte: jede Speise mit Preis, Allergenen und Verfügbarkeit. Gesperrte/ausverkaufte
 *  Speisen sind sichtbar, aber nicht bestellbar (Knopf deaktiviert). */
export function Speisekarte({ speisen, onHinzufuegen }: Props) {
  if (speisen.length === 0) {
    return <p className="hinweis">Die Speisekarte ist derzeit leer.</p>;
  }

  return (
    <ul className="speiseliste">
      {speisen.map((speise) => (
        <li key={speise.id} className={speise.bestellbar ? "speise" : "speise gesperrt"}>
          <div className="speise-kopf">
            <span className="speise-name">{speise.name}</span>
            <span className="speise-preis">{euro(speise.stueckpreisCent)}</span>
          </div>
          <div className="speise-meta">
            <span className="allergene">
              Allergene: {speise.allergene.length > 0 ? speise.allergene.join(", ") : "keine"}
            </span>
            {!speise.bestellbar && <span className="nicht-verfuegbar">derzeit nicht bestellbar</span>}
          </div>
          <button
            type="button"
            className="knopf primaer"
            disabled={!speise.bestellbar}
            onClick={() => onHinzufuegen(speise)}
          >
            In den Warenkorb
          </button>
        </li>
      ))}
    </ul>
  );
}
